import {Component, OnInit, ViewChild} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import {  Router } from '@angular/router';
import {GeneralService} from "../services/general.service"
import { HttpClient } from '@angular/common/http';
import { AvtListesComponent } from '../avt-listes/avt-listes.component';
import { AvtDialogDeleteComponent } from '../avt-dialog-delete/avt-dialog-delete.component';

@Component({
  selector: 'app-liste-clients',
  templateUrl: './liste-clients.component.html',
  styleUrls: ['./liste-clients.component.scss']
})
export class ListeClientsComponent implements OnInit {

  dataSource = [];
  columns = {TableRD : []}
  exist;
  displayedColumns= [];
  tbrecherche: any[];
  param : string;
  client;
  showTableClient : boolean = false;
  showButton : boolean = true;
  constructor(public dialog: MatDialog,public http: HttpClient,public router:Router,public route: ActivatedRoute,public generalService :GeneralService) 
  {
    
  }
  @ViewChild("listeClientComponen",{static:false}) listeClientComponen : AvtListesComponent;
  ngOnInit() 
  {
    this.readParamUrl();
    
  }  
  init(getCol : boolean = true)
  {
    if(this.param == '2')    
      this.client = "PROSPECT";     
    else if(this.param == '1')    
      this.client = "CLIENTS";          
    else if(this.param == '3')         
      this.client = "FOURNISSEURS";   

    this.getColumnClient(getCol);
  }
  choisirDocument()
  {
    if(this.listeClientComponen.row)
    {
      this.generalService.rowChoisie = this.listeClientComponen.row;
      this.generalService.dialogOpend.close();
    }
    else
      this.generalService.dialogSuccess("Veuillez sélectionner une seule ligne",false);
  }
  getColumnClient(getCol : boolean = true)
  {
    if(getCol)
      this.generalService.rechercheTable(this.generalService.urlColumnClientaborateur).subscribe(data =>       
      {   
        this.columns =  data;
        this.columns["read_Only"] = true;
        this.columns.TableRD[1].TableRD_Type = 101;
        this.getDataClient();
      });
    else
      this.getDataClient();
  }
  exportToExcel()
  {
    this.generalService.exportToExcel(this.listeClientComponen, "LISTE" + this.client.toUpperCase())
  }
  getDataClient()
  {
    this.generalService.rechercheTable(this.generalService.urlListeClientByType+this.param).subscribe(data => 
    {   
      this.dataSource = data;
      var tabHref = []
      data.forEach(row => 
      {
        tabHref.push({popap : true,href:['/w/avt/client/'+row.Tiers_Code+'/3/'+this.param],row:row})
      });
      this.columns.TableRD[1]["tabHref"] = tabHref;
      this.showTableClient = true;
      this.exist = true
       
    },()=>
    {
      this.exist = true
    });
  }


  planning()
  {
    if (this.listeClientComponen.row != undefined) 
      this.router.navigate(['avt/planningclient',this.listeClientComponen.row.Tiers_Code.toString()]);
    else
      this.generalService.dialogSuccess("Veillez sélectionner une ligne",false)
  }
  afficher(typeTrs)
  {
    if (this.listeClientComponen.row != undefined ) 
    {
      this.generalService.popupCenter("/w/avt/client" + "/" + this.listeClientComponen.row.Tiers_Code + "/" + typeTrs + "/" + this.param)
      // this.router.navigate(['avt/client',this.listeClientComponen.rows[0].Tiers_Code,typeTrs,this.param]);
    }
    else
      this.generalService.dialogSuccess("Veillez sélectionner une ligne",false)
  }
  supprimer()
  {
    if (this.listeClientComponen.row != undefined) 
    {
      const dialogConfig = this.generalService.dialogConfig;
      dialogConfig.autoFocus = true;
      var dialogRef = this.generalService.dialog.open(AvtDialogDeleteComponent, dialogConfig);
      dialogRef.afterClosed().subscribe(result =>
      {
        if(result == "supprimer")
        {
          var compt = 1//this.listeClientComponen.rows.length;
          this.exist = false;
          [this.listeClientComponen.row].forEach(client => 
          {
            var deleteFn = this.generalService.supprimerSanMsgConfirm(client.Tiers_Code,"avtclient");
            if(deleteFn != null)
            {
              deleteFn.subscribe(data => 
              {
                compt--;
                if(compt == 0)
                {
                  this.getDataClient()
                }
                this.generalService.dialogSuccess("Elément supprimer",true);
              },
              error =>
              {
                compt--;
                this.generalService.dialogSuccess("Elément non supprimé",false);
                this.exist = true;
              });
            }
          });
          
        }
        if(result == "annuler")
        {
        }
      });

    }
    else
      this.generalService.dialogSuccess("Veuillez sélectionner une ou plusieurs lignes",false)
  }
  radioTypeChange(event)
  {
    this.exist = false
    this.init(false)
  }
  readParamUrl()
  {
    this.route.params.subscribe(params => 
    {
      this.param = params['param'];
      if(!this.generalService.isNotEmpty(this.param))
      {
        this.param = this.generalService.paramListeClient
        this.showButton = false;
      }
     
      this.init()
    });
  }
}



